import { render, staticRenderFns } from "./VersionDetailsContainer.vue?vue&type=template&id=eb9d95f2"
import script from "./VersionDetailsContainer.vue?vue&type=script&lang=js"
export * from "./VersionDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports